import React from 'react';
import extend from 'object-assign';
import enTranslations from './locales/drupal-en';

/* eslint no-param-reassign: 0 */

const enBaseStrings = enTranslations || undefined;

// Attempting to detect all html elements that could have been inserted through translation strings.
const regexHtmlElement = /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i;

const DrupalMock = {
  t: (str, args, options) => {
    options = options || {};
    options.context = options.context || '';

    if (typeof enBaseStrings !== 'undefined' && enBaseStrings.strings && enBaseStrings.strings[options.context] && enBaseStrings.strings[options.context][str]) {
      str = enBaseStrings.strings[options.context][str];
    }

    if (args) {
      str = DrupalMock.formatString(str,
        args);
    }

    return str;
  },
  formatString: (str, args) => {
    // Keep args intact.
    const processedArgs = {};
    // Transform arguments before inserting them.
    for (const key in args) {
      if (args.hasOwnProperty(key)) {
        switch (key.charAt(0)) {
          // Escaped only.
          case '@':
            processedArgs[key] = DrupalMock.checkPlain(args[key]);
            break;

          // Pass-through.
          case '!':
            processedArgs[key] = args[key];
            break;

          // Escaped and placeholder.
          default:
            processedArgs[key] = DrupalMock.theme('placeholder',
              args[key]);
            break;
        }
      }
    }

    return DrupalMock.stringReplace(str,
      processedArgs,
      null);
  },
  checkPlain: str => str.toString()
    .replace(/&/g,
      '&amp;')
    .replace(/"/g,
      '&quot;')
    .replace(/</g,
      '&lt;')
    .replace(/>/g,
      '&gt;'),
  // we mock it to only allow for placeholder to work.
  theme: () => {
    const args = Array.prototype.slice.apply(args,
      [1]);
    return `<em class="placeholder">${DrupalMock.checkPlain(args[0])}</em>`;
  },
  stringReplace: (str, args, keys) => {
    if (str.length === 0) {
      return str;
    }

    // If the array of keys is not passed then collect the keys from the args.
    if (!Array.isArray(keys)) {
      keys = [];
      for (const k in args) {
        if (args.hasOwnProperty(k)) {
          keys.push(k);
        }
      }

      // Order the keys by the character length. The shortest one is the first.
      keys.sort((a, b) => a.length - b.length);
    }

    if (keys.length === 0) {
      return str;
    }

    // Take next longest one from the end.
    const key = keys.pop();
    const fragments = str.split(key);

    if (keys.length) {
      for (let i = 0; i < fragments.length; i++) {
        // Process each fragment with a copy of remaining keys.
        fragments[i] = DrupalMock.stringReplace(fragments[i],
          args,
          keys.slice(0));
      }
    }

    return fragments.join(args[key]);
  },
};

// Using the mock in case Drupal is not defined.
const Drupal = window.Drupal || DrupalMock;

const translate = {
  translate: (str, args, options, component) => {
    options = extend({'context': 'booking'},
      options);
    args = args || {};
    component = component || 'span';
    const translation = Drupal.t(str,
      args,
      options);

    // if the translation contains html we need to wrap it in a span
    // to render it correctly. (else it will output escaped html code.
    if (regexHtmlElement.test(translation)) {
      return React.createElement(component,
        {
          dangerouslySetInnerHTML: {__html: translation},
        });
    }

    return translation;
  },
};

export default translate;
